// extracted by mini-css-extract-plugin
module.exports = {"notOwner":"TackBack_notOwner__2iD6R","text":"TackBack_text__3Nusj","buttons":"TackBack_buttons__1BPJ7","takeBack":"TackBack_takeBack__2k5wx","title":"TackBack_title__B4_DM"};